import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isApiPackageConsultationOpen: false,
}

const modalsSlice = createSlice({
  name: 'modals',
  initialState,
  reducers: {
    showApiPackageConsultationModal(state) {
      state.isApiPackageConsultationOpen = true
    },
    hideApiPackageConsultationModal(state) {
      state.isApiPackageConsultationOpen = false
    },
  },
})

export const {
  showApiPackageConsultationModal,
  hideApiPackageConsultationModal,
} = modalsSlice.actions
export const reducer = modalsSlice.reducer
